export const timeLogs = (state) => state.timeLogs
export const selectAllField = (state) => state.selectAllField
export const selectedTimeLogs = (state) => state.selectedTimeLogs
export const totalTimeLogs = (state) => state.totalTimeLogs
export const selectedViewTimeLog = (state) => state.selectedViewTimeLog
